<template>
    <div class="bgc">
      <!-- 退款 -->
      <div style="height:12px;background:#F2F2F2"></div>
      <div class="cart_viewCell" >
        <div class="celss" @click="GoCoupon(0)">
          <van-cell center  value="仅退款" is-link />
        </div>
      </div>
      <!-- 退货 -->
      <div class="cart_viewCell" >
        <div class="celss" @click="GoCoupon(1)">
          <van-cell center  value="退货退款" is-link />
        </div>
      </div>
    </div>
</template>
<script>
import { Cell } from 'vant'
export default {
  components: {
    [Cell.name]: Cell
  },
  data() {
    return {

    }
  },
  methods: {
    GoCoupon(i) {
      // 0 退款
      // 1 退货
      // 2 售后记录
      if (i === 0) {
        // this.$router.push('/refund')
        // var data = JSON.stringify(this.dataObject)
        this.$router.push({ path: '/refund', query: { data: this.$route.query.data, orderId: this.$route.query.orderId } })
      } else if (i === 1) {
        this.$router.push({ path: '/ReturnGoods', query: { data: this.$route.query.data, orderId: this.$route.query.orderId } })
      }
      // else if (i === 2) {
      //   this.$router.push('/afterrecords')
      // }
    }
  }
}
</script>
<style lang="less" scoped>
.bgc{
  background:#F2F2F2;
  min-height: 96vh;
}
  .cart_viewCell{
    background-color: #fff;
    height: 100px;
    border-bottom: 1px solid #EEEEEE; /*no*/
  .celss{
    /deep/ .van-cell{
      font-size: 28px;
      line-height: 80px;
      padding-left: 30px;
    }
    /deep/ .van-cell__right-icon{
      line-height: 35px;
      font-size: 35px;
    }
    /deep/ .van-cell__value--alone{
      text-align: center;
    }
  }
}
</style>
